<script>
import { link, push, location } from 'svelte-spa-router';
import { onMount } from 'svelte';
import { curUser } from '../user.js';
import * as user from '../user.js';
import * as utils from '../utils';
import Header from './header.svelte';
import ModalLoading from './modals/loading.svelte';

let userState = '';
let inProgress = false;
let inProgressLink = '/';
curUser.subscribe((u) =>
{
    if (u === null) // null means we don't yet know if they are signed in or not
        return;

    userState = 'nosession';
    if (u && u.auth)
    {
        if (u.subscriptionState === 'active')
        {
            userState = 'active';
        }
        else
        {
            if (u.signUpState)
            {
                userState = 'inprogress';
            }
        }
    }
});

onMount(() =>
{
    window.scrollTo(0, 0);
});

function ToLitmos()
{
    ShowModal(ModalLoading, {}, (() => {}));

    user.ToLitmos();
}


</script>

<Header/>

<!-- Banner -->
  <section id="banner">
    <div class="inner">
    {#if userState === 'active'}
      <h2>Say good-bye to lectures. Say hello to one-of-a-kind,<br />
      collaborative CME courses. <br /></h2>
      <h4>Experience the Spine Management Summit 2023 and weekly Summit Rounds</h4>
<!--      <ul class="actions special">-->
<!--        <li>-->
<!--            <a href={"javascript:void(0)"} on:click={ToLitmos} class="button no-border">GO TO COURSES</a>-->
<!--        </li>-->
<!--      </ul>-->
    {:else if userState === 'inprogress'}
        <h2>Welcome back! It looks like you signed up but didn't complete the registration</h2>
      <ul class="actions special">
        <li>
            <a href="/signup/create" use:link class="button no-border">CONTINUE SIGN-UP</a>
        </li>
      </ul>
    {:else if userState === 'nosession'}
      <h2>Say good-bye to lectures. Say hello to one-of-a-kind,<br />
      collaborative CME courses. <br /></h2>
      <h4>Experience the Spine Management Summit 2023 and weekly Summit Rounds</h4>
<!--      <h5>Unlimited course access $29.99/mo</h5>-->
<!--      <ul class="actions special">-->
<!--        <li>-->
<!--            <a href="/signup/create" use:link class="button no-border">SUBSCRIBE</a>-->
<!--        </li>-->
<!--        </ul>-->
<!--        <p class="footnote">Already signed up? <a href="/signin" use:link>Sign-In here</a></p>-->

    {/if}
    </div>
    <a href="#one" class="more scrolly">Learn more ...</a>
  </section>


  <!-- Main -->
    <div class="container main">

      <!-- Three -->
        <section id="three" class="feature">
          <div class="row">
            <div class="col-6 col-12-medium">
              <div class="box alt">
                <div class="row gtr-uniform gtr-50">
                  <div class="col-12 col-12-xsmall">
                    <a href='/signup/create' use:link class="image fit">
                      <img src="images/SummitUnlimited.png" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 col-12-medium imp-medium">
            <p>We believe that many minds create better outcomes. </p>
              <p>So we invite providers of many different disciplines to examine and discuss patient care from every angle. And now you can have a seat at the table.</p>
              <p>With Summit Unlimited, you'll have access to our weekly Summit Rounds, plus all sessions of the Spine Management Summit 2023, a national conference held at Sundance, Utah. </p>
              <p>You'll learn from neurosurgeons, physical therapists, chiropractors, nurse practitioners, pain doctors - and more - as they each lend their expertise to relevant spine, brain, and orthopedic cases.</p>
              <p>Our goal is to dramatically improve patient care in our community. And yours. </p>
<!--              <ul class="actions">-->
<!--              {#if userState === 'nosession'}-->
<!--                <li><a href="/signup/create" use:link class="button">SUBSCRIBE</a></li>-->
<!--              {:else}-->
<!--                <li><a href={"javascript:void(0)"} on:click={user.ToLitmos} class="button">GO TO COURSES</a></li>-->
<!--              {/if}-->
<!--              </ul>-->
            </div>
          </div>
        </section>


        <!-- Three -->
          <section id="courseThumbnails" class="feature">
            <div class="row">
              <div class="col-12 col-12-medium">
                <header class="major">
                  <h3>Unlimited Access</h3>
                  <p>Watch weekly content, learn from different providers, get CME credit - all on your own time.</p>
                </header>
            </div>
              <div class="col-12 col-12-medium">
                <div class="box alt">
                  <div class="row gtr-uniform gtr-50">
                    <div class="col-3 col-12-xsmall">
                      <div class="image fit">
                        <img src="images/summitConference.png" alt="Summit Conference Course" />
                      </div>
                    </div>
                    <div class="col-3 col-12-xsmall">
                      <div class="image fit">
                        <img src="images/summitRounds.png" alt="Summit Rounds Course" />
                      </div>
                    </div>
                    <div class="col-3 col-12-xsmall">
                      <div class="image fit">
                        <img src="images/summitPractice.png" alt="Summit Practice Course" />
                      </div>
                    </div>
                    <div class="col-3 col-12-xsmall">
                      <div class="image fit">
                        <img src="images/summitPatient.png" alt="Summit Patient Course" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- Three -->
            <section id="faculty" class="feature">
              <div class="row">
                <div class="col-6 col-12-medium imp-medium">
                  <header class="major">
                    <h3>Meet our faculty</h3>
                  </header>
                  <p>Our faculty consists of medical professionals from various disciplines. Each plays a role in our Summit Rounds
                      where we discuss patient care from every angle.</p>
                  <ul class="actions">
                    <li><a href="/#/faculty" class="button">SEE OUR FACULTY</a></li>
                  </ul>
                </div>
                <div class="col-6 col-12-medium">
                  <div class="box alt">
                    <div class="row gtr-uniform gtr-50">
                      <div class="col-12 col-12-xsmall">
                        <a href="/faculty" use:link class="image fit">
                          <img src="images/faculty.png" alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>



  </div>

<style>
#banner h4, #banner h5 { font-weight: 500; }

h3, p{
  color: #fff;
}

#header h1 a {
  font-size: 1em;
}
#header nav ul li.special { border-left: none; }
#header {
  border-bottom: .5em solid #1a232f;
}
li, li > a {
  width: 75%;
}

/* Banner */
#banner {
  background-size: cover;
  height: calc(100vh - 4.75em);
}

p.footnote > a:hover {color: #1c1d1e !important;}
#banner h2 {margin: 0 0 .2em 0;}

@media screen and (max-width: 736px) {
#banner {
    height: auto;
    min-height: 0;
    padding: 4em 0;
}}

.button.no-border {
  border: none !important;
  box-shadow: none !important;
  background-color: #1a242f;
  color: #fff;
}

.button.no-border:hover {
  border: none;
  background-color: #273444 !important;
  color: #fff !important;
}

/* Section One */
#main.container {
  padding: 4.75em 0 2.5em 0;
}

.button {
  color: #fff !important;
}

.button:hover {
  color: #1c1d1e !important;
  background-color: #fff;
  box-shadow: none;
  border: 1px solid #1c1d1e;
}

@media screen and (max-width: 480px){
#courseThumbnails .col-12-xsmall {
    width: 50%;
}}

@media screen and (max-width: 736px){
#courseThumbnails .col-12-xsmall {
    width: 50%;
}}

</style>
